import { Command, AssertV, AddSchema, Schema, GetSchemaJSON, AssertValidate } from "mobx-firelink";
import { GetEvent } from "Store/firebase/events";
import { DeepSet, Clone } from "js-vextensions";
const MTName = "BookEvent";
AddSchema(`Update${MTName}_payload`, [MTName], () => ({
    properties: {
        id: { $ref: "UUID" },
        updates: Schema({
            properties: GetSchemaJSON(MTName).properties.Including("characters", "week", "day", "seed", "text", "placeholderCount", "steps", "fullText"),
            // maybe temp
            patternProperties: {
                "characters/.+": {},
                "steps/.+": {},
            },
        }),
    },
    required: ["id", "updates"],
}));
//@UserEdit // temp removed, so only one change in update, so completes faster (batches are slow atm, for some reason)
export class UpdateBookEvent extends Command {
    Validate() {
        AssertValidate(`Update${MTName}_payload`, this.payload, "Payload invalid");
        const { id, updates } = this.payload;
        this.oldData = GetEvent(id);
        AssertV(this.oldData, "oldData is null.");
        if (updates.Pairs().Any(a => a.key.includes("/"))) {
            this.newData = Clone(this.oldData);
            for (const pair of updates.Pairs()) {
                DeepSet(this.newData, pair.key, pair.value);
            }
        }
        else {
            this.newData = { ...this.oldData, ...updates };
        }
        AssertValidate(MTName, this.newData, `New ${MTName.toLowerCase()}-data invalid`);
    }
    GetDBUpdates() {
        const { id } = this.payload;
        const updates = {};
        updates[`events/${id}`] = this.newData;
        return updates;
    }
}
